export const VISIBLE_TIME_OUT = 300;

export const LANGUAGE_LIST = ["ko", "en"];

export const SIZES = {
    PC: '1536px',
    TABLET_L: '1280px',
    TABLET: '1024px',
    MOBILE_L: '768px',
    MOBILE: '640px',
};

export const NOT_ALLOW_LANG = ["solutions", "wearable"];

export const IMPACT_ICONS = {
    USE: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M12.89 1.45a3 3 0 0 0-3.78 0L2.6 6.5C1.82 6.95 1.82 8.05 2.6 8.5L5 9.8 12 14l7-4.2 2.4-1.35c.78-.45.78-1.55 0-2L12.89 1.45z" />
            <path d="M14.8 9.8L22 14l-7.2 4.2-7.2 4.2-7.2-4.2V9.8l7.2 4.2 7.2-4.2z" />
        </svg>
    ),
    TREE: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path
                d="M18 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-3V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16z"/>
            <path d="M12 2v4"/>
        </svg>
    ),
    CARBON: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M22 12h-4V8h-2c0-2.76-2.24-5-5-5a5.003 5.003 0 0 0-4.66 3H5a3 3 0 0 0 0 6h.75"/>
            <path d="M19 19l-7-7-7 7"/>
            <line x1="17" y1="17" x2="7" y2="7"/>
        </svg>
    ),
}


